import { Done, ExpandMore, FmdBad, InfoRounded, Widgets } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Autocomplete, Box, Chip, FormHelperText, Grid, Tooltip, Typography } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import Api from '../../Api';
import {
    IComboBoxOption,
    ILocationFormSection, IMaterial, IMaterialSiteComboBoxOption, MaterialContext
} from '../../interfaces';
import { Values } from '../../utils';
import { DatePicker } from '../Shared/FormControls/DatePicker';
import { MaterialSplitDialog } from '../MaterialSplitDialog';
import { cloneDeep } from 'lodash';


export const LocationFormSection: React.SFC<ILocationFormSection> = ({
    material,
    onUpdate,
    onSplit,
    arrivalOnly,
    ...props
}: ILocationFormSection) => {

    useEffect(() => {

        Values.setValues("sites", setSites).then((data) => {


        });


        Values.setValues("storagetypes", setStorageTypes).then((data) => {


        });


    }, []);


    useEffect(() => {

        console.log("material here", material);


        if (nextPallet === "")
            Api.Materials.getNextPallet().then((resp: any) => {
                setNextPallet(resp.pallet.toString())
            });

        if (material.storedAssemblyId && !storedAssembly)
            Api.Materials.get(material.storedAssemblyId).then(response => {
                let storedAssembly = response as IMaterial;
                setStoredAssembly(storedAssembly);
            })

    }, [material])

    const getWarehouses = () => {

        let site = sites.filter(x => x.value === material.site?.value)[0];

        if (site && site.getWarehouses) {
            return site.getWarehouses;
        }
        else return [];
    }

    const updateRackSuggestions = (value: string) => {

        if (value.length > 2) {

            let warehouseId = material.warehouse?.id ?? "no_warehouse_id";

            Api.Materials.Search.rack(warehouseId, value).then((data) => {
                setRackSuggestions((data as string[])
                    .map(x => { return { id: x, value: x } }));
            })

        } else {
            setRackSuggestions([]);
        }
    }

    const updateRowSuggestions = (value: string) => {

        if (value.length > 2) {

            let warehouseId = material.warehouse?.id ?? "no_warehouse_id";

            Api.Materials.Search.row(warehouseId, value).then((data) => {
                setRowSuggestions((data as string[])
                    .map(x => { return { id: x, value: x } }));
            })

        } else {
            setRowSuggestions([]);
        }
    }


    const isExternal = () => {
        return material.site?.value?.toUpperCase().startsWith("EXTERNAL");
    }

    const isRefit = () => {

        if (!storedAssembly) return false;

        if (storedAssembly.site?.id !== material.site?.id) return false;
        if (storedAssembly.warehouse?.id !== material.warehouse?.id) return false;
        if (storedAssembly.rack !== material.rack) return false;
        if (storedAssembly.row !== material.row) return false;
        if (storedAssembly.pallet !== material.pallet) return false;

        return true;

    }

    const onRefit = async () => {
        if (storedAssembly) {

            if (storedAssembly.site !== material.site)
                await onUpdate("site", storedAssembly.site ?? {});
            if (storedAssembly.warehouse !== material.warehouse)
                await onUpdate("warehouse", storedAssembly.warehouse ?? {});
            if (storedAssembly.rack !== material.rack)
                await onUpdate("rack", storedAssembly.rack ?? "");
            if (storedAssembly.row !== material.row)
                await onUpdate("row", storedAssembly.row ?? "");
            if (storedAssembly.pallet !== material.pallet)
                await onUpdate("pallet", storedAssembly.pallet ?? "");
        }
    }


    const [sites, setSites] = useState<IMaterialSiteComboBoxOption[]>([]);
    const [storageTypes, setStorageTypes] = useState<IComboBoxOption[]>([]);
    const [rackSuggestions, setRackSuggestions] = useState<IComboBoxOption[]>([]);
    const [rowSuggestions, setRowSuggestions] = useState<IComboBoxOption[]>([]);
    const [nextPallet, setNextPallet] = useState("");
    const [storedAssembly, setStoredAssembly] = useState<IMaterial>();


    return (

        <Accordion defaultExpanded={true}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <DialogContentText color="primary">
                    Location
                </DialogContentText>

            </AccordionSummary>
            <AccordionDetails>

                {arrivalOnly ? <></> : <>
                    <Grid container>
                        {storedAssembly &&
                            <Grid item xs={12}>
                                <Tooltip title="set the location and pallet number to match the stored assembly">
                                    <Chip
                                        icon={<Widgets />}
                                        label={isRefit() ? <>Fitted to <strong>{storedAssembly.l3}</strong></> : <>Refit to <strong>{storedAssembly.l3}</strong>?</>}
                                        variant={isRefit() ? "filled" : "outlined"}
                                        color={isRefit() ? "info" : "default"}
                                        deleteIcon={isRefit() ? <Done /> : <></>}
                                        onDelete={onRefit}
                                        onClick={onRefit}
                                        sx={{ mb: 2 }}
                                    />
                                </Tooltip>
                            </Grid>
                        }
                        <Grid item={true} xs={6} sx={{ p: 0.5 }}>

                            <Autocomplete
                                id="material-site"
                                color=""
                                options={sites.map(x => x.value)}
                                value={material.site?.value || null}
                                onChange={(_, value) => onUpdate("site", { value, id: sites.filter(x => x.value === value)[0]?.id })}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Site"
                                    required
                                    helperText="Where is the material stored"

                                />}
                            />
                        </Grid>

                        <Grid item={true} xs={6} sx={{ p: 0.5 }}>
                            <Autocomplete
                                id="material-warehouse"
                                options={getWarehouses()?.map(opt => opt.value as string)}
                                value={material.warehouse?.value || null}
                                onChange={(_, value) => onUpdate("warehouse", { value, id: getWarehouses().filter(x => x.value === value)[0]?.id })}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Warehouse"
                                    required={!isExternal()}
                                    helperText={isExternal() ? "Warehouse not applicable for external site" : "Select from the available options"}

                                />}
                                disabled={isExternal()}
                            />
                        </Grid>

                    </Grid>
                    <Grid container>
                        <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                            <Autocomplete
                                id="material-storageType"
                                options={storageTypes.map(opt => opt.value as string)}
                                value={material.storageType?.value || null}
                                onChange={(_, value) => onUpdate("storageType", { value, id: storageTypes.filter(x => x.value === value)[0]?.id })}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Storage Type"
                                    required
                                />}
                                disabled={isExternal()}
                            />
                        </Grid>
                        <Grid item={true} xs={2} sx={{ p: 0.5 }}>

                            <Autocomplete
                                id="material-rack"
                                options={rackSuggestions.map(opt => opt.value as string)}
                                freeSolo
                                filterOptions={(x) => x}
                                value={material.rack}
                                onInputChange={(event: object, value: string, reason: string) => {
                                    if (reason === 'input') {
                                        updateRackSuggestions(value);
                                        onUpdate("rack", value.toUpperCase())
                                    }
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Rack"
                                    required={!isExternal()}

                                />}
                            />

                        </Grid>
                        <Grid item={true} xs={2} sx={{ p: 0.5 }}>

                            <Autocomplete
                                id="material-row"
                                options={rowSuggestions.map(opt => opt.value as string)}
                                freeSolo
                                filterOptions={(x) => x}
                                value={material.row}
                                onInputChange={(event: object, value: string, reason: string) => {
                                    if (reason === 'input') {
                                        updateRowSuggestions(value);
                                        onUpdate("row", value.toUpperCase())
                                    }
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Row"
                                    required={!isExternal()}

                                />}
                            />

                        </Grid>
                      
                        <Grid item={true} xs={4} sx={{ p: 0.5 }}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                label="Pallet Number"
                                value={material.pallet}
                                onChange={(e) => onUpdate("pallet", e.currentTarget.value.replace(/[^0-9]/g, ''))}
                                inputProps={{
                                    type: "number",
                                    step: 1
                                }}
                                type="number"
                                required={!isExternal()}
                                placeholder={nextPallet}
                            />
                        </Grid>

                        <FormHelperText sx={{ mb: 1 }} ><FmdBad />The location details of all materials with this pallet number will be updated if this material changes.</FormHelperText>

                    </Grid>

                </>}



                <Grid container>
                    <Grid item={true} xs={arrivalOnly ? 12 : 4} sx={{ p: 0.5 }}>
                        <DatePicker
                            variant="outlined"
                            label="Arrival Date"
                            value={material.arrivalDate}
                            onChange={(date) => onUpdate("arrivalDate", date)}
                            required={true}
                            nullable={true}
                        />
                    </Grid>
                </Grid>
                {
                    (material.quantity && material.quantity > 1) && onSplit &&
                    <Grid container alignItems="center">
                        <Box sx={{ m: .5 }}>
                            <MaterialSplitDialog
                                quantity={material.quantity as number}
                                onSubmitMaterial={onSplit}
                            />
                        </Box>

                        <Typography variant="subtitle2">If the material is being stored in multiple locations you can split it.</Typography>

                    </Grid>


                }


            </AccordionDetails>
        </Accordion>

    );
}